<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <span>Отразить горизонтально</span>
        <v-switch
          inset
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :input-value="listItem.data.horizontalFlip"
          :value="listItem.data.horizontalFlip"
          @change="mixChangeListItemHandler($event, 'horizontalFlip')"
        />
      </v-col>
    </v-row>
    <v-row>
      <QuillEditorVue
        :cols="12"
        :title="'Текст'"
        :content="listItem.data.text"
        :disabled="isLoading"
        :loading="isLoading"
        :isShowErrorMessage="true"
        :errorText="errorMessages.text"
        light-mode
        @input="mixChangeListItemHandler($event, 'text')"
        @onChangeContent="mixChangeListItemHandler($event, 'descriptionForMobile')"
      />
    </v-row>
    <v-row align="center">
      <v-col cols="6">
        <v-row no-gutters align="center">
          <v-col cols="6">
            <v-row no-gutters align="center">
              <MediaFilePicker
                :multiple="false"
                :label="'Медиа файл'"
                :isShowCaption="true"
                :caption="listItem.data.caption"
                :file-type="$options.mediaTypesByKeys.IMAGE"
                :value="listItem.data.image"
                @change="mixUploadImageHandler($event, 'image')"
                @change-caption="mixChangeListItemHandler($event, 'caption')"
              >
                <template #preview-bottom>
                  <ErrorMessage :message="errorMessages.image" />
                </template>
              </MediaFilePicker>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <span>Заполнение изображения</span>
        <v-select
          outlined
          item-value="value"
          item-text="title"
          return-object
          hide-details
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.fit ? listItem.data.fit : $options.imageFits[1]"
          :items="$options.imageFits"
          @change="mixChangeListItemHandler($event, 'fit')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <span>Ширина</span>
        <v-text-field
          outlined
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="fields.inputWidth"
          :error-messages="errorMessages.width"
          @input="ChangingHandler($event, 'Width', 'input')"
        />
      </v-col>
      <v-col cols="6">
        <span>Ед. измерения</span>
        <v-select
          outlined
          item-value="value"
          item-text="title"
          hide-details
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="fields.valueWidth"
          :items="$options.valueTypesCSSList"
          @change="ChangingHandler($event, 'Width', 'value')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <span>Высота</span>
        <v-text-field
          outlined
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="fields.inputHeight"
          :error-messages="errorMessages.height"
          @input="ChangingHandler($event, 'Height', 'input')"
        />
      </v-col>
      <v-col cols="6">
        <span>Ед. измерения</span>
        <v-select
          outlined
          item-value="value"
          item-text="title"
          hide-details
          dense
          :disabled="isLoading"
          :loading="isLoading"
          :value="fields.valueHeight"
          :items="$options.valueTypesCSSList"
          @change="ChangingHandler($event, 'Height', 'value')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix.js'

import imageFits from '@/configs/imageFits'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'
import valueTypesCSSList from '@/configs/valueTypesCSS'

import MediaFilePicker from '@/components/media-file-picker/MediaFilePicker.vue'
import ErrorMessage from '@/components/error-messages/ErrorMessage'
import QuillEditorVue from '@/components/quill-editor'
const regex = /(px|em|%|in|pt+)$/gim

export default {
  name: 'TextAndImageWidget',
  mediaTypesByKeys: mediaTypesByKeys(),
  mixins: [dynamicListItemMix],
  imageFits,
  valueTypesCSSList,
  components: {
    ErrorMessage,
    MediaFilePicker,
    QuillEditorVue
  },
  data () {
    return {
      fields: {
        valueWidth: null,
        valueHeight: null,
        inputWidth: null,
        inputHeight: null
      }
    }
  },
  computed: {
    returnWidth () {
      return this?.listItem?.data?.width.toString() || null
    },
    returnHight () {
      return this?.listItem?.data?.height.toString() || null
    }
  },
  methods: {
    populateSize (field) {
      switch (field) {
        case 'width':
          this.fields.inputWidth = this.returnWidth?.replace(regex, '')
          this.fields.valueWidth = this.returnWidth?.slice(
            this.returnWidth?.search(regex)
          )
          break
        case 'height':
          this.fields.inputHeight = this.returnHight?.replace(regex, '')
          if (this.returnHight?.match(regex)) {
            this.fields.valueHeight = this.returnHight?.slice(
              this.returnHight?.search(regex)
            )
          } else {
            this.fields.valueHeight = 'px'
          }
          break
        default:
          break
      }
      this.inputWidth = this.returnWidth?.replace(regex, '')
      const idxWidth = this.returnWidth?.search(regex)
      this.valueWidth = this.returnWidth?.slice(idxWidth)
    },
    ChangingHandler (payload, field = 'Width', typeSize = 'input') {
      const stateField = `${typeSize}${field}`
      this.fields[stateField] = payload
      this.mixChangeListItemHandler(
        String(this.fields[`input${field}`] + this.fields[`value${field}`]).trim(),
        field.toLowerCase()
      )
    }
  },
  mounted () {
    this.populateSize('width')
    this.populateSize('height')
  }
}
</script>
